import React, { memo } from 'react';
import {
  MailAddressPropertyFree,
  MailAddressFreeInput,
  FormPageInputItemMailAddressFree,
} from 'shared';
import { FormFieldInputItemProps } from '../shared';

type Props = FormFieldInputItemProps<
  MailAddressPropertyFree,
  FormPageInputItemMailAddressFree
> & {
  mailAddress: FormPageInputItemMailAddressFree['mailAddress'];
};

const MAIL_ADDRESS_KEY: Extract<
  keyof FormPageInputItemMailAddressFree,
  'mailAddress'
> = 'mailAddress';

export const MailAddressFree: React.FC<Props> = memo(
  ({
    property,
    disabled,
    design,
    mailAddress,
    onChange,
    onBlur,
    className,
    errorMessages,
    displayError,
    reEnter,
  }) => {
    const { propertyId, inputFormat } = property;
    const { placeholder } = inputFormat;

    const handleChange = (
      mailAddress: FormPageInputItemMailAddressFree['mailAddress']
    ) => {
      onChange(MAIL_ADDRESS_KEY, mailAddress);
    };
    const handleBlur = (
      mailAddress: FormPageInputItemMailAddressFree['mailAddress']
    ) => {
      onBlur(MAIL_ADDRESS_KEY, mailAddress);
    };
    return (
      <MailAddressFreeInput
        propertyId={propertyId}
        placeholder={reEnter ? '' : placeholder}
        mailAddress={mailAddress}
        disabled={disabled}
        displayError={displayError}
        errorMessages={errorMessages}
        onChange={handleChange}
        onBlur={handleBlur}
        design={design}
        className={className}
      />
    );
  }
);
